module.exports = __webpack_public_path__ + "img/certificate02-1-3.d266d3b7.jpg";